import { type Region } from '@heidi/schema/ml-scribe';
import { createContext, useContext } from 'react';

export type QueryUserKindeProperties = {
  region: Region | undefined;
  rawRegion?: string;
  epicUserId?: string | null;
  connectionId?: string | null;
};

export type QueryKindePropertiesQueryResult = {
  data: QueryUserKindeProperties | undefined;
  isLoading: boolean;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
  isFetching: boolean;
  refetch: () => Promise<unknown>;
};

export const initialKindePropertiesQueryResult: QueryKindePropertiesQueryResult = {
  data: undefined,
  isLoading: false,
  isPending: true,
  isSuccess: false,
  isError: false,
  error: null,
  isFetching: false,
  refetch: () => Promise.resolve({ data: undefined }),
};

// Keep Kinde bootstrap state separate so this layer can be removed with Kinde.
export const KindePropertiesContext = createContext<QueryKindePropertiesQueryResult>(
  initialKindePropertiesQueryResult
);

export const useCurrentKindePropertiesQueryResult =
  (): QueryKindePropertiesQueryResult => {
    return useContext(KindePropertiesContext);
  };

export { KindePropertiesProvider } from './kinde-properties-provider';
